import { render, staticRenderFns } from "./PolicyHolderSummary.vue?vue&type=template&id=24ab222e&scoped=true&"
import script from "./PolicyHolderSummary.vue?vue&type=script&lang=js&"
export * from "./PolicyHolderSummary.vue?vue&type=script&lang=js&"
import style0 from "./PolicyHolderSummary.vue?vue&type=style&index=0&id=24ab222e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab222e",
  null
  
)

export default component.exports